// src/hooks/useAppConfig.js
import { useQuery } from 'react-query';

export function useAppConfig() {
    return useQuery(
        'appConfig',
        () => fetch('/api/health').then(res => res.json()),
        {
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
            refetchOnWindowFocus: false
        }
    );
}

// Then use it in your component:
// import { useAppConfig } from '../../hooks/useAppConfig';
//
// function EmailNotificationsTab() {
//     const { data: appConfig } = useAppConfig();
//     const isEmailConfigured = appConfig?.features?.emailFullyConfigured ?? false;
//
//     // ... rest of component
// }